import { gsap } from 'gsap';

export const carouselUtils = () => {
  const carousels = document.querySelectorAll('.is-style-carousel');

  carousels.forEach(carousel => {
    // Create a container for the slides
    const slidesContainer = document.createElement('div');
    slidesContainer.className = 'carousel-slides';

    // Add 'carousel-slide' class to each child and move them into the new container
    Array.from(carousel.children).forEach(child => {
      if (child.classList.contains('wp-block-group') && !child.classList.contains('navigation')) {
        child.classList.add('carousel-slide');
        slidesContainer.appendChild(child);
      }
    });

    // Insert the slides container at the beginning of the carousel
    carousel.insertBefore(slidesContainer, carousel.firstChild);

    const slides = Array.from(slidesContainer.querySelectorAll('.carousel-slide'));
    let currentSlide = 0;

    // Create navigation container and buttons (if they don't already exist)
    let nav = carousel.querySelector('.navigation');
    let prevButton, nextButton;
    if (!nav) {
      nav = document.createElement('div');
      nav.className = 'navigation';
      prevButton = document.createElement('button');
      prevButton.textContent = '';
      prevButton.className = 'nav-prev';
      nextButton = document.createElement('button');
      nextButton.textContent = '';
      nextButton.className = 'nav-next';
      nav.appendChild(prevButton);
      nav.appendChild(nextButton);
      carousel.appendChild(nav);
    } else {
      prevButton = nav.querySelector('.nav-prev');
      nextButton = nav.querySelector('.nav-next');
    }

    // Function to handle Vimeo videos
    function handleVimeoVideo(iframe, action) {
      const player = new Vimeo.Player(iframe);
      if (action === 'pause') {
        player.pause();
      } else if (action === 'reset') {
        player.setCurrentTime(0);
      }
    }

    // Function to update the blurred background
    function updateBlurredBackground(slide) {
      const image = slide.querySelector('.wp-block-image img');
      if (image) {
        const heroBg = document.querySelector('.site-hero__bg');
        if (heroBg) {
          // Create or update an inner div for the blurred background
          let blurredBg = heroBg.querySelector('.blurred-bg-inner');
          if (!blurredBg) {
            blurredBg = document.createElement('div');
            blurredBg.className = 'blurred-bg-inner';
            heroBg.appendChild(blurredBg);
          }

          // Apply styles to the parent element
          heroBg.style.overflow = 'hidden';

          // Apply styles to the inner element
          blurredBg.style.backgroundImage = `url('${image.src}')`;
          blurredBg.style.filter = 'blur(20px)';
          blurredBg.style.position = 'absolute';
          blurredBg.style.top = '-40px';
          blurredBg.style.left = '-40px';
          blurredBg.style.right = '-40px';
          blurredBg.style.bottom = '-40px';
          blurredBg.style.backgroundPosition = 'center';
          blurredBg.style.backgroundSize = 'cover';
        }
      }
    }

    // Function to show a specific slide
    function showSlide(n) {
      // Pause and reset video on the current slide
      const currentIframe = slides[currentSlide].querySelector('iframe[src*="vimeo.com"]');
      if (currentIframe) {
        handleVimeoVideo(currentIframe, 'pause');
        handleVimeoVideo(currentIframe, 'reset');
      }

      slides[currentSlide].classList.remove('active');
      slides[n].classList.add('active');
      currentSlide = n;

      // Update the blurred background
      updateBlurredBackground(slides[n]);
    }

    // Event listeners for navigation buttons
    prevButton.addEventListener('click', () => {
      let n = currentSlide > 0 ? currentSlide - 1 : slides.length - 1;
      showSlide(n);
    });

    nextButton.addEventListener('click', () => {
      let n = currentSlide < slides.length - 1 ? currentSlide + 1 : 0;
      showSlide(n);
    });

    // Initialize: Make sure only one slide is active and set initial background
    slides.forEach((slide, index) => {
      if (index === currentSlide) {
        slide.classList.add('active');
        updateBlurredBackground(slide);
      } else {
        slide.classList.remove('active');
      }
    });

    // Load Vimeo API
    const script = document.createElement('script');
    script.src = 'https://player.vimeo.com/api/player.js';
    document.body.appendChild(script);
  });

  // Find images
  carousels.forEach(carousel => {
    // Find all wp-block-cover elements within the carousel
    const covers = carousel.querySelectorAll('.wp-block-cover');

    covers.forEach(cover => {
      // Check if the cover has a child with class 'wp-block-cover__image-background'
      if (cover.querySelector('.wp-block-cover__image-background')) {
        // Find the closest parent wp-block-column, if it exists
        const column = cover.closest('.wp-block-column');

        // If a parent column was found, add the class
        if (column) {
          column.classList.add('has-image-child');
        }
      }
    });
  });
};
